import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const leaveHistorySlice = createSlice({
  name: "leaveHistory",

  initialState: { leaveHistory: [], refreshLeaveHistory: false },
  reducers: {
    setAllLeaveHistory: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.leaveHistory = payload;
    },
    setRefreshLeaveHistory: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.refreshLeaveHistory = payload;
    },
    resetAllLeaveHistory: (state) => {
      state.leaveHistory = [];
    },
  },
});

export const {
  setAllLeaveHistory,
  resetAllLeaveHistory,
  setRefreshLeaveHistory,
} = leaveHistorySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default leaveHistorySlice.reducer;
